import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const EngineNo = (props) => {
  return (
    <FormGroup controlId="engineNo">
      <Col componentClass={ControlLabel} sm={5}>
        Engine Number
      </Col>
      <Col sm={7}>
        <FormControl type="text" value={props.engine} onChange={props.handleChangeEngine} autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

EngineNo.propTypes = {
  engine: PropTypes.string,
  handleChangeEngine: PropTypes.func
};

export default EngineNo;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/engineNo/EngineNo.js